import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { NEW_MINIMUM_AGREEMENT_RATE } from 'src/app/pages/agreements/constants/minimum-agreement-rate.contants';

@Injectable({
  providedIn: 'root',
})
export class MinimumRateService {
  constructor() {}

  /**
   * Sets the minimum agreement rate.
   */
  fetchMinimumAgreementRate$(): Observable<number> {
    return of(NEW_MINIMUM_AGREEMENT_RATE);
  }
}
